import { app } from '../../../../../app';
import { Controller } from './recovery-reminder.controller';

app.component('recoveryReminder', {
    controller: Controller,
    templateUrl: require('./recovery-reminder.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/recovery-settings/recovery-reminder/recovery-reminder.component.js